module.exports = __webpack_public_path__ + "img/hidden04.c4b8dd82.jpg";